var _rect, _ellipse, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLocation = function SvgLocation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    transform: "translate(0.5)",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5,
    cy: 91,
    rx: 23,
    ry: 2,
    fill: "url(#paint0_linear_1003_11765)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.6815 31.9481C73.2419 16.8137 60.0403 10 48.4438 10C48.4438 10 48.4438 10 48.4438 10C48.4438 10 48.4438 10 48.4111 10C36.8474 10 23.613 16.781 20.1734 31.9153C16.3407 48.8186 26.6923 63.134 36.0612 72.1426C39.5336 75.4839 43.9887 80.9588 48.4438 80.9588C52.899 80.9588 57.3541 75.4839 60.7937 72.1426C70.1626 63.134 80.5143 48.8514 76.6815 31.9481ZM48.4438 48.36C42.7439 48.36 38.125 43.7411 38.125 38.0412C38.125 32.3412 42.7439 27.7223 48.4438 27.7223C54.1438 27.7223 58.7627 32.3412 58.7627 38.0412C58.7627 43.7411 54.1438 48.36 48.4438 48.36Z",
    fill: "url(#paint1_linear_1003_11765)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1003_11765",
    x1: 26.2667,
    y1: 91.8,
    x2: 68.4345,
    y2: 91.0653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEFF1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECEFF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1003_11765",
    x1: 19.3545,
    y1: 43.5698,
    x2: 68.419,
    y2: 52.5372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLocation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "location.e8b37e97fc842f3c9548cda1daefb83b.svg";